import React from "react"

import { RosterCategoryProvider } from "./src/components/context/RosterCategoryContext"
import { HeaderContextProvider } from "./src/components/context/HeaderContext"

export const wrapRootElement = ({ element }) => {
  return (
    <RosterCategoryProvider>
      <HeaderContextProvider>{element}</HeaderContextProvider>
    </RosterCategoryProvider>
  )
}
